import React from 'react';
import _ from 'lodash';

import { IRosterShift } from '../../types';
import { WorkerShiftCard } from '../../cards/worker-shift-card';
import { ROSTER_TAB } from 'views/bookings-v2/bookings-roster-view/components/roster-common-enums';

interface WorkerShiftCardListProps {
  shifts: IRosterShift[][];
}

export const WorkerShiftCardList = ({ shifts }: WorkerShiftCardListProps) => {
  return (
    <>
      {shifts.map((shiftGroup, rowIdx) =>
        shiftGroup.map((shift, shiftIdx) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
          <WorkerShiftCard shift={shift} key={shiftIdx} tab={ROSTER_TAB.DAILY} rowIndex={rowIdx} />
        )),
      )}
    </>
  );
};
